import produce from 'immer';
import {
  fetchUserAccess,
  fetchUserBilling,
  fetchUserProfile,
  updateUserProfile,
  hydrateUserProfile,
} from '@user/redux/routines';

import profileReducer, {
  getInitialProfileState,
  ProfileState,
} from './profileReducer';

import accessReducer, {
  AccessState,
  getInitialAccessState,
} from './accessReducer';
import billingReducer, {
  BillingState,
  getInitialBillingState,
} from './billingReducer';

import type { Plans } from '@components/OurPlans/components/Plans/interface';

export interface UserState {
  initialised: boolean;
  readonly access: AccessState;
  readonly billing: BillingState;
  readonly profile: ProfileState;
  readonly selectedMarket: string;
  readonly plans: Plans;
}

export const getUserState = (): UserState => ({
  initialised: false,
  access: getInitialAccessState(),
  billing: getInitialBillingState(),
  profile: getInitialProfileState(),
  selectedMarket: '',
  plans: {},
});

export default function reducer(
  state = getUserState(),
  action: ReducerAction = { type: '', payload: {} }
): UserState {
  return produce(state, (draft) => {
    switch (action.type) {
      case fetchUserBilling.SUCCESS:
        try {
          draft.billing = billingReducer(state.billing, action);
        } catch (e: any) {
          console.error('Reducer: fetchUserBilling  failed', {
            ...e,
            ...action,
          });
        }
        break;
      case fetchUserProfile.SUCCESS:
      case updateUserProfile.TRIGGER:
      case updateUserProfile.SUCCESS:
      case updateUserProfile.FAILURE:
      case hydrateUserProfile.SUCCESS:
        try {
          draft.profile = profileReducer(state.profile, action);
          draft.initialised = true;
        } catch (e: any) {
          console.error('Reducer: fetchUserProfile.SUCCESS failed', {
            ...e,
            ...action,
          });
        }
        break;
      case fetchUserAccess.SUCCESS:
        try {
          draft.access = accessReducer(
            state.access,
            action as ReturnType<typeof fetchUserAccess['success']>
          );
        } catch (e: any) {
          console.error('Reducer: fetchUserAccess.SUCCESS failed', {
            ...e,
            ...action,
          });
        }
        break;
    }
  });
}
